import React from "react";
import Slider from "react-slick";
import dummyImg from '../images/no-image-thumb.jpg';

const PlanCarousel = ({ images }) => {
  const PrevArrow = ({ onClick }) => (
    <button className=" floor-arrow-prev " onClick={onClick}>
      {"<"}
    </button>
  );

  const NextArrow = ({ onClick }) => (
    <button className="floor-arrow-next" onClick={onClick}>
      {">"}
    </button>
  );

  const settings = {
    dots: false,
    infinite: false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          centerMode: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (!images || images.length === 0) {
    return null; // If there are no images, don't render anything
  }

  return (
    <section className="spot-section sectiontopgap">
      <div className="content content_margin">
        <div className="container">
          <Slider {...settings}>
            {images.map((image, index) => (
              <div className="featureslides" key={index}>
                <div className="fslidebox">
                  <div className="featurebox">
                    <img
                      src={image.image}
                      alt={`Floor Plan ${index + 1}`}
                      onError={(e) => {
                          e.target.onerror = null; // prevent infinite loop
                          e.target.src = dummyImg; // ✅ use variable directly
                      }}
                      style={{
                        width: '100%',
                        height: "300px",
                        objectFit: "cover",
                        border: '2px solid #E4E4E4'
                      }}
                    />
                  </div>
                </div>
              </div>
              // <div className="topproslides" key={index}>
              //   <img
              //       src={image.image}
              //       alt={`Floor Plan ${index + 1}`}
              //       style={{
              //         width: "100%",
              //         height: "250px",
              //         objectFit: "cover"
              //       }}
              //     />
              // </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default PlanCarousel;
